class QuestionarioAdapter {
  toNumberOrNull(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const numero = Number(value);
    return Number.isNaN(numero) ? null : numero;
  }

  mapPendencia(resultadoVerificacao) {
    const data = resultadoVerificacao?.data || {};
    const campanha = data.campanha || {};
    return {
      success: Boolean(resultadoVerificacao?.status),
      hasPendencia: Boolean(data.temPendencia),
      cdCooperado: resultadoVerificacao?.cdCooperado || null,
      cdProced: campanha.pendencia || data.cdProced || null,
      tipoPendencia: campanha.tipoPendencia || null,
      mensagem: campanha.mensagem || data.mensagem || "",
      error: resultadoVerificacao?.error || null
    };
  }

  mapQuestionarioInicial(resultadoInicio) {
    const data = resultadoInicio?.data || {};
    const questionario = data?.pergunta || data?.questionario || data;

    return {
      success: Boolean(resultadoInicio?.success),
      error: resultadoInicio?.error || null,
      questionarioData: this.mapPergunta(questionario),
      titulo: questionario.ds_proced || "Questionario de acompanhamento"
    };
  }

  mapPergunta(pergunta = {}) {
    const totalPerguntas = this.toNumberOrNull(pergunta.total_perguntas);
    const perguntaAtual =
      this.toNumberOrNull(pergunta.pergunta_atual) ??
      this.toNumberOrNull(pergunta.sq_exibicao);
    const porcentagem = this.toNumberOrNull(
      pergunta.porcentagem ?? pergunta.percentual
    );

    return {
      cd_pergunta: pergunta.cd_pergunta || null,
      cd_proced: pergunta.cd_proced || null,
      ds_pergunta: pergunta.ds_pergunta || "",
      ds_instrucao: pergunta.ds_instrucao || "",
      ds_observacao: pergunta.ds_observacao || "",
      tipo_resposta: pergunta.tipo_resposta || "D",
      obrigatorio: pergunta.obrigatorio || "N",
      total_perguntas: totalPerguntas,
      pergunta_atual: perguntaAtual,
      porcentagem,
      ultima_pergunta: Boolean(pergunta.ultima_pergunta),
      respostas: Array.isArray(pergunta.respostas)
        ? pergunta.respostas.map(resposta => ({
            cd_resposta: resposta.cd_resposta,
            ds_resposta: resposta.ds_resposta || "",
            selecionada: Boolean(resposta.selecionada),
            obrigatorio: resposta.obrigatorio || "N",
            ds_observacao: resposta.ds_observacao || null
          }))
        : []
    };
  }

  mapPerguntas(perguntas = []) {
    if (!Array.isArray(perguntas)) {
      return [this.mapPergunta(perguntas)];
    }

    return perguntas.map(pergunta => this.mapPergunta(pergunta));
  }

  mapRespostasPayload(respostas = {}) {
    return Object.entries(respostas).map(([cdPergunta, valor]) => ({
      cd_pergunta: cdPergunta,
      resposta: Array.isArray(valor) ? valor.join(",") : valor
    }));
  }

  mapRespostaBackendPayload({
    cdCooperado,
    cdProced,
    cdPergunta,
    cdResposta,
    voltando = 0
  } = {}) {
    const respostaFormatada =
      cdResposta && typeof cdResposta === "object" && !Array.isArray(cdResposta)
        ? `cd_resposta|${cdResposta.cd_resposta ||
            ""}|ds_resposta|${cdResposta.ds_resposta || ""}`
        : Array.isArray(cdResposta)
        ? cdResposta
            .filter(
              valor => valor !== null && valor !== undefined && valor !== ""
            )
            .map(valor => `cd_resposta|${valor}`)
            .join("|")
        : cdResposta !== null && cdResposta !== undefined && cdResposta !== ""
        ? `cd_resposta|${cdResposta}`
        : null;

    const payload = {
      cdCooperado: this.toNumberOrNull(cdCooperado),
      cdProced: this.toNumberOrNull(cdProced),
      cdPergunta: this.toNumberOrNull(cdPergunta),
      voltando
    };

    if (respostaFormatada) {
      payload.cdResposta = respostaFormatada;
    }

    return payload;
  }

  mapVoltarPerguntaPayload = ({
    cdCooperado,
    cdProced,
    cdPergunta,
    cdResposta,
    voltando = 1
  } = {}) => {
    return {
      cdCooperado: this.toNumberOrNull(cdCooperado),
      cdProced: this.toNumberOrNull(cdProced),
      cdPergunta: this.toNumberOrNull(cdPergunta),
      cdResposta: this.toNumberOrNull(cdResposta),
      voltando
    };
  };
}

export const questionarioAdapter = new QuestionarioAdapter();
